import { Box, Stack } from '@mui/material';
import type { AvailableReportKey, ReportCatalogEntry, ReportGroupKey } from '@parkchirp/reporting';
import type { ReactNode } from 'react';
import { ReportNavigation } from './ReportNavigation';

type Props = {
	children: ReactNode;
	selectedReportKey: AvailableReportKey | null;
	navigationDisabled: boolean;
	canAccessReport: (reportKey: ReportCatalogEntry['key']) => boolean;
	onSelectReport: (reportType: AvailableReportKey) => void;
	reportGroupKeys?: ReportGroupKey[];
	showReportGroupHeaders?: boolean;
};

export const ReportingLayout = ({
	children,
	selectedReportKey,
	navigationDisabled,
	canAccessReport,
	onSelectReport,
	reportGroupKeys,
	showReportGroupHeaders,
}: Props) => {
	return (
		<Box
			sx={{
				bgcolor: 'background.default',
				minHeight: 'calc(100vh - 48px)',
				width: '100%',
			}}
		>
			<Stack
				spacing={2.5}
				sx={{
					width: '100%',
				}}
			>
				<Box
					sx={{
						alignItems: 'flex-start',
						display: 'flex',
						gap: 3,
						minWidth: 960,
					}}
				>
					<ReportNavigation
						selectedReportKey={selectedReportKey}
						disabled={navigationDisabled}
						canAccessReport={canAccessReport}
						onSelectReport={onSelectReport}
						reportGroupKeys={reportGroupKeys}
						showReportGroupHeaders={showReportGroupHeaders}
					/>

					<Box
						component='main'
						sx={{
							flex: 1,
							minWidth: 0,
						}}
					>
						{children}
					</Box>
				</Box>
			</Stack>
		</Box>
	);
};
